import { pollingService } from '@philips-emr/hpms-provider-accreditation-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import { InactivityAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.INACTIVITY })
class InactivityController extends BaseController {
  @OnMount(Aliases.PANEL_INACTIVITY)
  onMountPanelInactivity(): void {
    pollingService.removePolling('notification');
  }
}
export {
  InactivityController,
};
